import { Box, Skeleton, Typography } from "@mui/material";

import { memo } from "react";

import { useTranslation } from "next-i18next";

const HomeSkeleton = memo(() => {
  const { t } = useTranslation("features/dashboard");

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 900,
        margin: "60px auto",
        padding: 4,
        borderRadius: 2,
        backgroundColor: "background.paper",
        boxShadow: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      <Skeleton variant="rectangular" width="100%" height={60} sx={{ mb: 3, borderRadius: 2 }} />
      <Box sx={{ display: "flex", width: "100%" }}>
        <Box sx={{ width: 220, mr: 3 }}>
          <Skeleton variant="rectangular" width={220} height={400} sx={{ borderRadius: 2, mb: 2 }} />
          <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 2, mb: 1 }} />
          <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 2, mb: 1 }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 2, mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2, mb: 2 }} />
          <Skeleton variant="rectangular" width="60%" height={40} sx={{ borderRadius: 2, mb: 2 }} />
          <Skeleton variant="rectangular" width="40%" height={40} sx={{ borderRadius: 2, mb: 2 }} />
        </Box>
      </Box>
      <Skeleton variant="rectangular" width={300} height={48} sx={{ mt: 4, borderRadius: 2 }} />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          mt: 2,
          opacity: 0.8,
          fontStyle: "italic",
          textAlign: "center"
        }}
      >
        {t("Loading dashboard...")}
      </Typography>
    </Box>
  );
});

HomeSkeleton.displayName = "HomeSkeleton";

export default HomeSkeleton;
